import { Skeleton, SkeletonProps } from 'grommet';

type Props = object & SkeletonProps;

const TextSkeleton = ({ height = '0.75rem', width = 'full', round = 'xsmall', ...rest }: Props) => {
  return <Skeleton height={height} width={width} round={round} {...rest}/>;
};

export default TextSkeleton;
